import { Route, Routes } from 'react-router-dom';
import Page404 from '../pages/404';
import Order from '../pages/Order';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/order/:p1" element={<Order />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default AppRoutes;